import { HeadingType } from './HeadingType';

export const headingsTocStyles: { [key in HeadingType]: string } = {
    [HeadingType.Heading1]: `${HeadingType.Heading1}-reference`,
    [HeadingType.Heading2]: `${HeadingType.Heading2}-reference`,
    [HeadingType.Heading3]: `${HeadingType.Heading3}-reference`,
};
